import { type RouteComponentProps } from "react-router";

import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { type ILineItemsToInvoiceProps } from "commonComponents/entity/invoicing/LineItemsToInvoice/LineItemsToInvoice";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

const LineItemsToInvoice = lazyLoadWithRetry(() => import("./LineItemsToInvoice"));

export interface IRouteLineItemsToInvoiceProps<ActionType>
    extends Omit<ILineItemsToInvoiceProps<ActionType>, "history" | "location" | "match"> {
    onClose?: (routeProps: RouteComponentProps) => void;
}
export const RouteLineItemsToInvoice: React.FunctionComponent<
    IRouteLineItemsToInvoiceProps<any>
> = (props) => (
    <RouteRelative
        path={routes.lineItemsToInvoice.path}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <LineItemsToInvoice
                        {...props}
                        {...routeProps}
                        beforeClose={() => {
                            props.onClose?.(routeProps);
                            props.beforeClose();
                        }}
                    />
                </BTSuspense>
            );
        }}
    />
);
